var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 8.8203 8.8203 3 16 3H36C48.7025 3 59 13.2975 59 26V36C59 48.7025 48.7026 59 36 59H16C8.8203 59 3 53.1797 3 46V16Z",
    fill: "#9F86C0",
    fillOpacity: 0.2,
    stroke: "#22223B",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3226 15.8226C33.3226 14.2637 32.0589 13 30.5 13C28.9411 13 27.6774 14.2637 27.6774 15.8226V23.6774C27.6774 25.8866 25.8866 27.6774 23.6774 27.6774L15.8226 27.6774C14.2637 27.6774 13 28.9411 13 30.5C13 32.0589 14.2637 33.3226 15.8226 33.3226H23.6774C25.8866 33.3226 27.6774 35.1134 27.6774 37.3226V45.1774C27.6774 46.7363 28.9411 48 30.5 48C32.0589 48 33.3226 46.7363 33.3226 45.1774V37.3226C33.3226 35.1134 35.1134 33.3226 37.3226 33.3226H45.1774C46.7363 33.3226 48 32.0589 48 30.5C48 28.9411 46.7363 27.6774 45.1774 27.6774L37.3226 27.6774C35.1134 27.6774 33.3226 25.8866 33.3226 23.6774V15.8226Z",
    fill: "#22223B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.81019d6f3ef1366bdbc7807155178d04.svg";
export { ForwardRef as ReactComponent };